import { worshopSelection } from "api/Cart";
import { getDefaultWorkshop } from "../api/home";
import { FETCH_DEFAULT_WORKSHOP } from "../redux/actions/types";

export const workshopSelection = async (
  payload,
  workshopId,
  variantId,
  carModelId,
  carBrandId
) => {
  try {
    const { data } = await worshopSelection(
      payload,
      workshopId,
      variantId,
      carModelId,
      carBrandId
    );
    return data;
  } catch (error) {
    console.log('sldkjfsldkfjsdjf', error)
    return { err: error.message };
  }
};
